export const circleInCircleCollision = (
  xCircleCut: number,
  yCircleCut: number,
  xFixCirclePlace: number,
  yFixCirclePlace: number,
  radiusFixCircleCut: number,
) => {
  const distancesquared =
    (xCircleCut - xFixCirclePlace) * (xCircleCut - xFixCirclePlace) +
    (yCircleCut - yFixCirclePlace) * (yCircleCut - yFixCirclePlace);
  return distancesquared <= radiusFixCircleCut * radiusFixCircleCut;
};
